
import React from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import ConfiguracionProcesos from './ConfiguracionProcesos.jsx';
import * as actions from '../actions/Actions.js';

const mapStateToProps = (state) => {
    return {
        data: state.configuracionProcesos,
        tarjetas: state.tarjetas,
    }
}

const mapDispatchToProps = (dispatch) => { return bindActionCreators(actions, dispatch) }

const ConfiguracionProcesosContainer = connect(mapStateToProps, mapDispatchToProps)(ConfiguracionProcesos);


export default ConfiguracionProcesosContainer;